module.exports = __webpack_public_path__ + "img/knu_gallery10.fa9db6cd.jpg";